<template>
  <Modal title="编辑用户信息" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
      <Form ref="agent"  :model='agent' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
        <form-item label="代理手机号" prop="phone">
          <Input placeholder="请输入代理手机号，用户微信绑定" v-model="agent.phone"></Input>
        </form-item>
        <form-item label="状态" prop="status">
          <RadioGroup v-model="agent.status">
            <Radio :label="1" class="radio">启用</Radio>
            <Radio :label="2">禁用</Radio>
          </RadioGroup>
        </form-item>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" @click="handleOk('agent')"  :loading="loading">
        <span v-if="!loading">提交</span>
        <span v-else>提交中...</span>
      </Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { edits, agentUserInfo } from '@/api/agent'
export default {
  name: 'userEdit',
  props: ['id'],
  data () {
    return {
      isShow: false,
      userid: 0,
      loading: false,
      agent: {
        agent_id: 0,
        phone: '',
        status: 1,
      },
      ruleValidate: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    id (val) {
      this.userid = val
      if (this.userid > 0) {
        this.userInfo()
      }
    }
  },
  created () {
  },
  methods: {
    handle (status) {
      this.isShow = false
    },
    selectCate (val) {
      this.agent.area = val
    },
    handleOk (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // console.log(this.agent);return;
          this.loading = true
          edits(this.agent).then(res => {
            let msg = '添加成功'
            if (this.agent.agent_id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.$emit('updateStatusModel')
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
            this.loading = false
          })
        }
      })
    },
    userInfo () {
      if (this.userid) {
        agentUserInfo(this.userid).then(res => {
          this.agent = res.data
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    },
  }
}
</script>
